<template>
    <div class="GoodsTable">
        <div class="fangke_table_box">
            <p>
                <span>访客榜TOP5商品</span>
                <el-tooltip placement="top">
                    <div class="tooltip_content" slot="content">筛选时间内，店铺内访客数最高5个商品（商品仅包括需要付费的单品、专栏、大专栏、会员、训练营、社群、活动）。 转化率：付费用户数/访客数</div>
                    <img class="tooltip_icon" :src="icon1" alt="">
                </el-tooltip>
            </p>
            <el-table :data="visitorList" style="width: 100%">
                <el-table-column type="index" label="排名" width="80" align='center'></el-table-column>
                <el-table-column label="商品名称" width="300">
                    <template slot-scope="scope">
                        <div class="goods_name_box">
                            <img :src="scope.row.coveratturlid" alt="">
                            <div>
                                <p>{{scope.row.kmcname}}</p>
                                <p>{{scope.row.kmctype}}</p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="viewcount" label="商品访客数" align='center'></el-table-column>
                <el-table-column prop="conversionRate" label="转换率" align='center'></el-table-column>
            </el-table>
        </div>
        <div class="zhifu_table_box">
            <p>
                <span>支付榜TOP5商品</span>
                <el-tooltip placement="top">
                    <div class="tooltip_content" slot="content">筛选时间内，店铺内付费用户数最多的5个商品（商品仅包括需要付费的单品、专栏、大专栏、训练营、会员、社群、活动）</div>
                    <img class="tooltip_icon" :src="icon1" alt="">
                </el-tooltip>
            </p>
            <el-table :data="paymentList" style="width: 100%">
                <el-table-column type="index" label="排名" width="80" align='center'></el-table-column>
                <el-table-column label="商品名称" width="300">
                    <template slot-scope="scope">
                        <div class="goods_name_box">
                            <img :src="scope.row.coveratturlid" alt="">
                            <div>
                                <p>{{scope.row.kmcname}}</p>
                                <p>{{scope.row.kmctype}}</p>
                            </div>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="viewcount" label="商品访客数" align='center'></el-table-column>
                <el-table-column prop="conversionRate" label="转换率" align='center'></el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
export default {
    name: 'GoodsTable',
    props: ['goodsTableData'],
    data() {
        return {
            img: require('@/common/images/logo.png'),
            icon1: require('@/common/images/other/data_center_tools_icon@2x.png'),
            visitorList: [], // 访客榜List
            paymentList: [] // 支付榜List
        }
    },
    mounted() {},
    methods: {},
    filters: {},
    watch: {
        goodsTableData(newVal, oldVal) {
            if (JSON.stringify(newVal) === JSON.stringify(oldVal)) {
                return
            }
            this.$nextTick(() => {
                this.visitorList = this.goodsTableData.visitorList
                this.paymentList = this.goodsTableData.paymentList
            })
        }
    },
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.GoodsTable {
    display: flex;
    &>div{
        width: 50%;
    }
    .fangke_table_box, .zhifu_table_box{
        padding-right: 30px;
        &>P {
            display: flex;
            align-items: center;
            height:20px;
            line-height:20px;
            color: #606266;
            margin-bottom: 15px;
            img{
                margin-left: 10px;
                width: 14px;
                height: 14px;
                cursor: pointer;
            }
        }
        .el-table th>.cell {
            font-weight: 600;
        }
        .goods_name_box{
            display: flex;
            &>img{
                width: 106px;
                height: 60px;
                margin-right: 10px;
            }
            &>div{
                width: 166px;
                display: flex;
                flex-direction: column;
                justify-content: space-between;
                p:nth-of-type(1) {
                    width: 100%;
                    white-space: nowrap;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    word-break: break-all;
                }
                p:nth-of-type(2) {
                    color: #fff;
                    width:36px;
                    height:17px;
                    line-height:17px;
                    text-align: center;
                    background-color: #409EFF;
                    border-radius:2px;
                }
            }
        }
    }
    .zhifu_table_box {
        padding-right: 0px;
        padding-left: 30px;
    }
}
</style>
<style scoped>
.tooltip_content {
    color: #606266;
    padding: 0 15px;
    line-height: 20px;
    width: 320px;
}
</style>